import { fetchNftData } from "@/Groups/Pon/private/api/fetchNftData";

const Pon = {
  namespaced: true,

  state: {
    ponData: {},
    isLoading: false,
    isReady: false,
    error: null
  },

  actions: {
    async fetchPonData({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      
      try {
        const data = await fetchNftData();
        
        commit('SET_PON_DATA', data);
        commit('SET_READY', true);
      } catch (error) {
        commit('SET_ERROR', error.message || 'Failed to fetch NFT data');
        console.error('Error fetching PON data:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },

    resetPonState({ commit }) {
      commit('RESET_STATE');
    }
  },

  mutations: {
    SET_PON_DATA(state, payload) {
      state.ponData = payload;
    },

    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },

    SET_READY(state, isReady) {
      state.isReady = isReady;
    },

    SET_ERROR(state, error) {
      state.error = error;
    },

    RESET_STATE(state) {
      state.ponData = {};
      state.isLoading = false;
      state.isReady = false;
      state.error = null;
    }
  },

  getters: {
   
  }
}

export default Pon;